{
  "mappings": [
    {
      "category": "Account Information",
      "titles": [
        "Addresses and more.json",
        "Alerts",
        "All Contacts",
        "All Contacts.vcf",
        "ALERTS-SUBSCRIPTIONS.JSON",
        "ApplicationPermissions.json",
        "Calendar",
        "Contacts",
        "Device Information.json",
        "Devices - A list of devices (i.e. Nest, Pixel, iPhone, Galaxy, etc) which have accessed your Google account over the last 270 days.csv",
        "Devices.json",
        "Emails.html",
        "Emails.json",
        "Follow request received.html",
        "Follow request sent.html",
        "Followers.html",
        "Following.html",
        "Gmail",
        "Google Account",
        "Google Business Profile",
        "Google Finance",
        "Google Meet",
        "Google Pay",
        "Google Play Books",
        "Google Play Games",
        "Google Play Games Services",
        "Google Play Movies & TV",
        "Google Play Store",
        "Google Product Surveys",
        "Google Shopping",
        "Google Store",
        "Google Wallet",
        "Google Workspace Marketplace",
        "Google transactions",
        "GoogleNestConnect.json",
        "GoogleNestPartnerConnections.json",
        "Groups",
        "History.json",
        "HomeApp.json",
        "HomeHistory.json",
        "Installs.json",
        "Library.json",
        "Maps (your places)",
        "My Activity",
        "My Contacts",
        "My Contacts.vcf",
        "My labeled places",
        "MyActivity.html",
        "Notification Preferences.json",
        "OS Settings.json",
        "Order History.json",
        "Play Settings.json",
        "Player.html",
        "PlayerDataSave",
        "Playtime.html",
        "Profile",
        "Profile.json",
        "Promotion History.json",
        "Purchase History.json",
        "Purchases.json",
        "Questions and Answers",
        "Questions and Answers.json",
        "Ratings.json",
        "Requests for services",
        "Requests for services.json",
        "Returns and Repairs.json",
        "Saved Places.json",
        "Search",
        "Search Notifications",
        "Settings.json",
        "Starred in Android",
        "Starred in Android.vcf",
        "Streaming Services.json",
        "Tasks",
        "Tasks.json",
        "Timeline",
        "USER-SETTINGS.CSV",
        "USER-SUBSCRIPTIONS.CSV",
        "Vehicle profiles",
        "Vehicle profiles.json",
        "Watchlist.json",
        "Watchlists",
        "Your Follows.csv",
        "Your local followed places",
        "Your local followed places.csv",
        "activity-feed.json",
        "businessPersonalization.json",
        "conference_history_records.csv",
        "conference_history_retention.csv",
        "data.json",
        "deviceName.string",
        "followed_locations.txt",
        "followed_sources.txt",
        "followed_topics.txt",
        "gemini_gems_data.html",
        "gemini_scheduled_actions_data.html",
        "interventions.json",
        "meet_settings.json",
        "profile.csv",
        "uuid.string"
      ]
    },
    {
      "category": "User-Generated Content",
      "titles": [
        "Achievements.html",
        "Activity.html",
        "Addresses and more.json",
        "Blogger",
        "Bookmarks.html",
        "CATS & SOUP",
        "COOKING MAMA Let_s Cook\uff01",
        "Chess",
        "Circle",
        "Clash Royale",
        "Clash of Clans",
        "Cookie Run_ OvenBreak",
        "Cooking Fever",
        "Crossy Road",
        "Cut the Rope",
        "Cut the Rope 2",
        "Cut the Rope_ Experiments",
        "Cut the Rope_ Magic",
        "Deemo",
        "Draw a Stickman_ EPIC 2",
        "Experience.html",
        "Fantastic Beasts_ Cases",
        "FarmVille 2_ CountryEscape",
        "Fern Flower",
        "Fit In The Hole",
        "Flappy Bird",
        "Flip",
        "Fluffy Fall",
        "Focus Plant",
        "Food Fantasy",
        "Frozen Free Fall",
        "Games",
        "Gemini",
        "Geometry Dash",
        "Glow Burst",
        "Godus",
        "GrandChase",
        "Gravity Switch",
        "GridSwan",
        "HATSUNE MIKU_ COLORFUL STAGE!",
        "Hello, Bacteria",
        "Hidden City",
        "Homescapes",
        "Images.csv",
        "KleptoCats",
        "KleptoCats 2",
        "Light a Way",
        "Luna Story  A forgotten tale",
        "Luna Story II",
        "MARVEL Contest of Champions",
        "Maps (your places)",
        "MementoMori",
        "Merchant Reviews",
        "Merchant Reviews.csv",
        "Minion Rush_ infinite run game",
        "Mobile Legends_ Bang Bang",
        "My Cafe_ Recipes & Stories",
        "My Talking Angela",
        "N.O.V.A. Legacy",
        "Nasi Goreng",
        "PUBG Mobile",
        "Parralyzed",
        "Piano Tiles 2",
        "Piano stuff.html",
        "Piano stuff.json",
        "Picross Luna III",
        "Plague Inc",
        "Plants vs Zombies\u2122 2",
        "Polyforge",
        "Pop the Lock",
        "Popcorn Chef",
        "Postknight",
        "Potion Punch",
        "Product Reviews",
        "Product Reviews.csv",
        "Puzzlerama",
        "PvZ2-1.pvz2",
        "README",
        "REBUS - Absurd Logic Game",
        "RESTAURANT DASH_ GORDON RAMSAY",
        "Scores.html",
        "SimCity BuildIt",
        "Skyward",
        "Sling Kong",
        "SlingKongCharacters",
        "Somnus",
        "Soul Knight",
        "SoulKnightCloud",
        "Star Trek Timelines",
        "Super Starfish",
        "Symbology",
        "Tahu Bulat",
        "Tap Tap Dash",
        "TapTapDashSave",
        "TapTapDashSave_W1",
        "Teenage Mutant Ninja Turtles",
        "TerraGenesis_ Space Colony",
        "The Trail",
        "Top Farm",
        "Topsoil",
        "Twist",
        "Two Eyes",
        "Unknown Knights Pixel RPG",
        "Virtual Beggar",
        "Virtual Families 2",
        "When the Past was Around",
        "Wild Tamer",
        "Word Salad",
        "Zen Koi - Breed & Collect Fish",
        "Zen Koi 2",
        "ZigZag",
        "_inventory.json",
        "_remote_Plaza_iOS.dat",
        "_user.json",
        "activity-feed.json",
        "articles.txt",
        "data.json",
        "drinks.csv",
        "food.csv",
        "game-data",
        "gamedata.sav",
        "magazines.txt",
        "others.csv",
        "pjsekai",
        "plague_save",
        "recent activity",
        "recently viewed discussions.csv",
        "recently viewed groups.csv",
        "save",
        "save_data",
        "saved_game",
        "user data"
      ]
    },
    {
      "category": "Device and Browser Information",
      "titles": [
        "Access Log Activity",
        "Android Device Configuration Service",
        "ApplicationPermissions.json",
        "Chrome",
        "Device Information.json",
        "Devices - A list of devices (i.e. Nest, Pixel, iPhone, Galaxy, etc) which have accessed your Google account over the last 270 days.csv",
        "Devices.json",
        "Extensions.json",
        "GoogleNestConnect.json",
        "GoogleNestPartnerConnections.json",
        "History.json",
        "Home App",
        "HomeApp.json",
        "HomeHistory.json",
        "Linked Services.json",
        "OS Settings.json",
        "Play Settings.json",
        "SecurityAlarmClips.json",
        "Settings.json",
        "SoundSensing.json",
        "User State",
        "User State.json",
        "deviceName.string",
        "uuid.string"
      ]
    },
    {
      "category": "Activity Information",
      "titles": [
        "Activities - A list of Google services accessed by your devices (for example every time your phone synchronizes with your Gmail).csv",
        "Activity.html",
        "Alerts",
        "Angry Birds Epic",
        "Arcaea",
        "Arrow",
        "Asphalt 8 - Car Racing Game",
        "Automations.json",
        "BADLAND",
        "BEAT MP3 with YouTube",
        "Baby Deer  Nonogram",
        "Bio Inc",
        "BioInc",
        "Bistro Heroes",
        "Blackbox puzzles",
        "Blendoku 2",
        "Block Puzzle Jewel",
        "Bunny Cuteness Overload",
        "Calendar",
        "Chess",
        "Color Switch",
        "ConferenceHistory",
        "Cookie Run_ OvenBreak",
        "Crossy Road",
        "Cut the Rope",
        "Cut the Rope 2",
        "Cut the Rope_ Experiments",
        "Cut the Rope_ Magic",
        "Cytus",
        "Cytus II",
        "Discover",
        "Don_t Screw Up!",
        "Don_t Tap The White Tile",
        "Don_t Touch The Spikes",
        "DragonCity",
        "Dragons_ Rise of Berk",
        "Drive",
        "Emails.html",
        "Emails.json",
        "Fallout Shelter",
        "Fansipan - Shadow Knights",
        "First Summoner",
        "Flappy Bird",
        "Follow request received.html",
        "Follow request sent.html",
        "Followers.html",
        "Following.html",
        "Food Fantasy",
        "GameDB",
        "GameData",
        "Games",
        "Gmail",
        "Glow Burst",
        "Google Account",
        "Google Finance",
        "Google Meet",
        "Google Play Books",
        "Google Play Games",
        "Google Play Games Services",
        "Google Play Movies & TV",
        "Google Play Store",
        "Google Shopping",
        "Google Store",
        "Google Wallet",
        "Google Workspace Marketplace",
        "Google transactions",
        "GrandChase",
        "Groups",
        "Help",
        "Hitman_ Sniper",
        "Hotels",
        "Image Search",
        "Installs.json",
        "Keep",
        "Knife Hit",
        "Labeled places.json",
        "Lapse_ A Forgotten Future",
        "Legendary_ Heroes Saga",
        "Light a Way",
        "Living Alone2",
        "Maps",
        "Metadata.html",
        "Minion Rush_ infinite run game",
        "Mobile Legends_ Bang Bang",
        "Money sends and requests",
        "Money sends and requests.csv",
        "My Activity",
        "MyActivity.html",
        "News",
        "Not Not - A Brain-Buster",
        "Once Upon a Tower",
        "PUBG Mobile",
        "Piano Tiles 2",
        "Pigeon Pop",
        "Plague Inc",
        "PlayGameServicesCloudData",
        "Player.html",
        "PlayerDataSave",
        "Playtime.html",
        "Polyforge",
        "Pop the Lock",
        "Popcorn Chef",
        "Postknight",
        "Potion Punch",
        "Profile",
        "Profile.json",
        "Promotion History.json",
        "Purchase History.json",
        "Purchases.json",
        "Questions and Answers",
        "Questions and Answers.json",
        "Reading List.html",
        "Real Bike Stunts",
        "Recall.html",
        "Requests for services",
        "Requests for services.json",
        "Returns and Repairs.json",
        "Rolling Sky",
        "Saved",
        "Saved Games",
        "Scores.html",
        "Search",
        "Search Notifications",
        "Settings.json",
        "Sky",
        "Sling Kong",
        "Somnus",
        "Soul Knight",
        "SoulKnightCloud",
        "Star Trek Timelines",
        "Streaks.html",
        "Sudoku",
        "Super Starfish",
        "Takeout",
        "Tasks",
        "Tasks.json",
        "Tebak Kata Saku",
        "Timeline",
        "Top Farm",
        "Twist",
        "Unblock Me FREE",
        "Virtual Families 2",
        "Watchlists",
        "Workspace Studio",
        "YouTube",
        "Your Gaming Community",
        "Your Liked Content.csv",
        "Zen Koi - Breed & Collect Fish",
        "Zen Koi 2",
        "activity-feed.json",
        "conference_history_records.csv",
        "conference_history_retention.csv",
        "followed_sources.txt",
        "followed_topics.txt",
        "recent activity",
        "recently viewed discussions.csv",
        "recently viewed groups.csv"
      ]
    },
    {
      "category": "Location Information",
      "titles": [
        "Addresses and more.json",
        "Labeled places.json",
        "Maps (your places)",
        "My labeled places",
        "Saved Places.json",
        "Your local followed places",
        "Your local followed places.csv",
        "followed_locations.txt"
      ]
    },
    {
      "category": "Third-Party Information",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Communication Information",
      "titles": [
        "Alerts",
        "All Contacts",
        "All Contacts.vcf",
        "ALERTS-SUBSCRIPTIONS.JSON",
        "ApplicationPermissions.json",
        "Calendar",
        "Contacts",
        "Emails.html",
        "Emails.json",
        "Follow request received.html",
        "Follow request sent.html",
        "Followers.html",
        "Following.html",
        "Gmail",
        "Google Meet",
        "Groups",
        "History.json",
        "Installs.json",
        "Money sends and requests",
        "Money sends and requests.csv",
        "My Contacts",
        "My Contacts.vcf",
        "Notification Preferences.json",
        "OS Settings.json",
        "Play Settings.json",
        "Profile",
        "Profile.json",
        "Questions and Answers",
        "Questions and Answers.json",
        "Requests for services",
        "Requests for services.json",
        "Starred in Android",
        "Starred in Android.vcf",
        "Tasks",
        "Tasks.json",
        "To do list.html",
        "To do list.json",
        "USER-SUBSCRIPTIONS.CSV",
        "Watchlist.json",
        "Watchlists",
        "Your Follows.csv",
        "conference_history_records.csv",
        "conference_history_retention.csv",
        "googlegroups.com"
      ]
    },
    {
      "category": "Health and Fitness Information",
      "titles": ["no_matching_file"]
    }
  ]
}
